import { useFormik } from 'formik';
import { Button, Box, Typography } from '@mui/material';
import { useQueryClient } from 'react-query';
import Input from 'components/system/Input';
import { accountSettingsSchema } from 'schemas/account.schema';
import useUserStore from 'store/UserStore';

const Form = ({
  formInputLabels, formInitialState, buttonText, type,
}) => {
  const validationSchema = accountSettingsSchema(type);
  const { updateUserField } = useUserStore();
  const queryClient = useQueryClient();

  const formik = useFormik({
    initialValues: formInitialState,
    validationSchema,
    onSubmit: async (values) => {
      const updateUser = updateUserField(type);
      const success = await updateUser(values);
      if (success) {
        queryClient.invalidateQueries('account');
      }
    },
  });

  return (
    <>
      {type === 'password' && (
        <Box sx={{
          width: '659px',
          minHeight: '40px',
          marginBottom: '24px',
          marginTop: '-24px',
        }}
        >
          <Typography variant="subtitle" sx={{ color: '#A9B0BC' }}>
            {' '}
            Set a password with at least one letter, one numeral and 7 characters.
            Your new password must be different from previous used passwords.
          </Typography>
        </Box>
      )}
      <Box component="form">
        <Box style={{ display: 'flex', justifyContent: 'space-between' }}>
          {Object.entries(formInputLabels).map(([name, configs], index) => (
            <Input
              {...configs}
              key={name}
              value={formik.values[name]}
              error={formik.errors[name]}
              name={name}
              onChange={formik.handleChange}
              autoFocus={index === 0}
              width="46"
              sx={{
                width: '48%',
              }}
            />
          ))}
        </Box>
        <Box sx={{ display: 'flex' }}>
          <Button
            variant="contained"
            sx={{ marginTop: '24px' }}
            disabled={!formik.isValid}
            onClick={formik.handleSubmit}
          >
            {buttonText}
          </Button>
        </Box>

      </Box>
    </>
  );
};
export default Form;
